import styled from 'styled-components'

export const StyledVolumesStartStep = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 0 60px;

  .block {
    display: flex;
    justify-content: space-between;
  }

  .block:nth-child(odd) {
    flex-direction: row;
  }

  .block:nth-child(even) {
    flex-direction: row-reverse;
  }

  .block:nth-child(even) button {
    align-self: flex-end;
  }

  .blockText {
    width: 55%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .blockText h3 {
    flex-basis: auto;
  }

  .descriptionText {
    min-height: 80px;
  }

  .aiGeneratedIcon {
    width: 100px;
    height: 50px;
  }

  .blockText button {
    border-radius: 4px;
  }
`
